import React from "react";
import { ThreeTagEntity } from '../../prometeTags'
import './style.less'

interface Props {
  onClick?: (...args: any) => void;
  shape: 'round' | 'triangle' | 'sawtooth';
  items: ThreeTagEntity;
  style?: React.CSSProperties;
}

const clsPrefix = 'c-square-tag'

const SquareTag: React.FC<Props> = ({
  onClick = () => null,
  items,
  shape = 'round',
  style = {}
}) => {
  return (
    <div className={clsPrefix} style={{ cursor: 'pointer', ...style}} onClick={onClick}>
      {[0, 1, 2].map((_, index) => {
        // @ts-ignore
        const item = items[index];
        return (
          <span
          style={{ color: item.color, fontSize: item.size }}
          className={`item-background item-${shape}-${index}`}
        >{item.text}</span>
        )
      })}
    </div>
  )
}

export default SquareTag;